<template>
  <div class="mx-6">
    <v-row>
      <info
        :nameTaken="nameTaken"
        :info.sync="groupName"
        title="Course Name"
        id="group-name"
        :cols="6"
      />
      <info
        :info.sync="details.interface"
        title="Description"
        id="group-description"
        :cols="3"
      />
      <info
        :info.sync="details.club_friendly_name"
        title="Club Friendly Name"
        id="group-friendly"
        :cols="3"
        readOnly
      />
      <info
        :info.sync="details.launch_mode"
        title="Launch Mode"
        id="group-interface"
        readOnly
        :cols="3"
      />
      <info
        :info.sync="details.gpsi_server"
        title="GPSI Server"
        id="group-server"
        select
        :items="gpsi_server_items"
        :cols="3"
      />
      <info
        :info.sync="details.site_id"
        title="Site ID"
        id="group-site-id"
        :cols="3"
      />
      <info
        :info.sync="details.vistar_direct"
        title="vistar_direct"
        id="group-vistar-direct"
        :cols="3"
        select
        vistar
        :items="vistarOptions"
      />
      <info
        :info.sync="user"
        title="Contact"
        id="group-contact"
        :cols="3"
        select
        :items="userList"
      />
      <v-col cols="3">
        <div v-if="editable" class="mx-4 mt-n4">
          <VueGooglePlaces
            :api-key="googleKey"
            types="establishment"
            :enableGeolocation="false"
            country="us"
            placeholder="Input your place"
            @placechanged="onPlaceChanged"
          >
            <v-text-field
              color="secondary"
              class="my-5"
              style="height:29px;"
              filled
              dense
              placeholder=""
              id="address"
              label="Address"
              v-model="details.address_1"
            />
          </VueGooglePlaces>
        </div>
        <div v-else class="mx-4" id="group-address">
          <span class="px-2" style="font-size: 12px;">Address</span>
          <div
            class="d-flex align-center text-capitalize text-truncate px-2"
            style="border-bottom: solid 1px black; height:29px;"
          >
            <h3>{{ details.address_1 }}</h3>
          </div>
        </div>
      </v-col>
      <info
        :info.sync="details.address_2"
        title="Address 2"
        :cols="3"
        id="group-address-2"
      />
      <info
        :info.sync="details.city"
        title="City"
        :cols="3"
        id="group-city"
      />
      <info
        :info.sync="details.state"
        title="State"
        :cols="3"
        id="group-state"
      />
      <info
        :info.sync="details.zip"
        title="Zip"
        :cols="3"
        id="group-zip"
      />
      <info
        :info.sync="details.lat"
        title="Latitude"
        :cols="3"
        id="group-lat"
      />
      <info
        :info.sync="details.lng"
        title="Longitude"
        :cols="3"
        id="group-long"
      />
      <info :info.sync="email" title="Email" id="group-email" :cols="3" />
       <info :info.sync="phone" title="Phone" id="group-phone" phone :cols="3" />
    </v-row>
    <edit-ad-json />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import GroupDetailData from '@/mixins/GroupDetailData';
import Info from '@/components/group-details/Info';
import EditAdJson from '@/components/group-details/EditAdJson';

export default {
  components: {
    Info,
    EditAdJson,
  },
  mixins: [GroupDetailData],
  data() {
    return {
      gpsi_server_items: [
        'development',
        'beta',
        'production',
        'aCT production',
        'azure dev',
      ],
      vistarOptions: [
        { text: 'No Vistar', value: 0 },
        { text: 'Vistar Normal', value: 1 },
        { text: 'Vistar Direct', value: 2 },
      ],
      nameTaken: false,
    };
  },
  computed: {
    ...mapGetters({
      _users: 'account/getAdminsAndUsers',
      _areas: 'areas/getAreas',
      _client: 'account/getCurrentClient',
    }),
    googleKey() {
      return process.env.VUE_APP_GOOGLE_MAPS_API_KEY;
    },
    user: {
      get() {
        if (
          this.details.contact_name !== null
        ) {
          return {
            text: this.details.contact_name,
            value: {
              contact_name: this.details.contact_name,
              phone: this.details.phone,
              email: this.details.email,
            },
          };
        }
        return undefined;
      },
      set(val) {
        this.details.contact_name = val.contact_name;
        this.details.phone = val.phone;
        this.details.email = val.email;
      },
    },
    userList() {
      const users = [];
      this._users.map((user) => {
        if (user.contact) {
          users.push({
            text: user.contact.contact_name,
            value: {
              contact_name: user.contact.contact_name,
              phone: user.contact.phone,
              email: user.contact.email,
            },
          });
        }
      });
      return users;
    },
    groupName: {
      get() {
        return this.details.group_name;
      },
      set(val) {
        if (
          this._client.groups.find((group) => (
            group.group_name.toLowerCase() === val.toLowerCase()
              && group.uuid != this.details.uuid
          ))
        ) {
          this.nameTaken = true;
          this.$emit('setDuplicateTrue');
        } else {
          this.nameTaken = false;
          this.$emit('setDuplicateFalse');
          this.details.group_name = val;
        }
      },
    },
  },
  methods: {
    onPlaceChanged(e) {
      this.details.address_1 = `${e.street_number} ${e.route}`;
      this.details.city = e.locality;
      this.details.state = e.administrative_area_level_1;
      this.details.zip = e.postal_code;
      this.details.lat = e.latitude;
      this.details.lng = e.longitude;
    },
  },
  watch: {
    'details.group_name': function () {
      this.details.club_friendly_name = this.details.group_name
        .toLowerCase()
        .replace(/\s/g, '');
    },
  },
};
</script>
